<template>
  <div :class="[iconClass, 'vue-icon']">
    <addIcon v-if="name === 'add'" />
    <moreVert v-if="name === 'more-vert'" />
    <dustbinIcon v-if="name === 'dustbin'" />
    <settingsIcon v-if="name === 'settings'" />
    <messageIcon v-if="name === 'message'" />
    <clipIcon v-if="name === 'clip'" />
  </div>
</template>

<script>
import addIcon from './addIcon.vue';
import moreVert from './moreVert.vue';
import settingsIcon from './settingsIcon.vue';
import dustbinIcon from './dustbinIcon.vue';
import clipIcon from './clipIcon.vue';
import messageIcon from './messageIcon.vue';

export default {
  name: 'VueIcon',
  components: {
    addIcon, moreVert, dustbinIcon, settingsIcon, messageIcon, clipIcon,
  },
  props: {
    name: {
      type: String,
      required: true,
      validator(value) {
        return (['add', 'more-vert', 'settings', 'dustbin', 'message', 'clip'].indexOf(value) !== -1);
      },
    },
  },
  computed: {
    iconClass() {
      return `${this.name}-icon`;
    },
  },
};
</script>

<style scoped lang="less">
.vue-icon{
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
